import { Injectable } from '@angular/core';
import * as LogRocket from 'logrocket';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogRocketService {
  constructor() {
    if (environment.logRocket.enabled) {
      LogRocket.init(environment.logRocket.appID);
    }
  }

  identify(email: string, name: string) {
    if (environment.logRocket.enabled) {
      LogRocket.identify(email, { name, email });
    }
  }
}
